<script lang="ts">
import dayjs from "dayjs";
import {Button, Modal} from "flowbite-svelte";
import {createEventDispatcher} from "svelte";
import {roundToNearest15} from "$lib/utils/roundTime";

export let showCheckInModal = false;

export let assignee;

export let realTime = false;

const dispatch = createEventDispatcher();

$:{
    if(showCheckInModal){
        onScanCheckin()
    }
}

const onScanCheckin = () => {
    if(realTime){
        assignee.actualStart.value = new Date()
        assignee.actualStart.stamp = (new Date()).getTime()
    } else {
        assignee.actualStart.value = roundToNearest15();
        assignee.actualStart.stamp = assignee.actualStart.value.getTime()
    }
}

const makeCheckIn = (opt: string) => {
    showCheckInModal = false;
    if(opt === 'planned'){
        assignee.actualStart = {...assignee.plannedStart}
    }
    assignee.touched = Date.now()
    dispatch('selected')
    // showCards = [...showCards, currentAssignee];
    // checkIn(project.uuid, currentAssignee.id)
}

</script>

<Modal bind:open={showCheckInModal}>
    <div class="grid gap-3 grid-cols-2 my-10">
        <Button class="h-36 grid" on:click={() => makeCheckIn('actual')}>
            <div>Dienstbeginn Neu</div>
            <div class="text-2xl">{dayjs(assignee?.actualStart.value).format('HH:mm')} Uhr</div>
        </Button>
        <Button class="h-36 grid" on:click={() => makeCheckIn('planned')}>
            <div>Dienstbeginn Plan</div>
            <div class="text-2xl">{dayjs(assignee?.plannedStart.value).format('HH:mm')} Uhr</div>
        </Button>
    </div>
</Modal>